module.exports = __webpack_public_path__ + "static/media/metamask.8e095dbb.png";